export default __webpack_public_path__ + "static/people-d38d7e4a3809b85fa3b71f5249d2689a.mp4";